import React, { useState } from 'react';
import './Blog.css';

function Blog() {
  const [blogs] = useState([
    {
      _id: 'blog-1',
      title: 'A Day in My Life',
      content: `Morning:

I started my day by working out and getting myself physically locked in before shifting into reading. After training, I spent time with self-help and marketing/business books that help shape how I think about discipline, growth, and strategy. Some of the books that have influenced me are Think and Grow Rich by Napoleon Hill, The Compound Effect by Darren Hardy, and my current read, Competing Against Luck by Clayton M. Christensen.

Class & Consulting:

Later, I went to my IME Marketing Honors class at DePaul, where I worked on our current client consulting project. Right now, I am working with Daddl, a UAE-based date candy brand, to help develop a market entry strategy for India. This includes researching the Indian market, understanding consumer behavior, analyzing competitors, and thinking through how Daddl can position itself in a way that feels relevant and differentiated.

Projects:

After class, I continued studying and working on marketing projects. A lot of my work focuses on turning research into clear strategy, whether that means developing recommendations, building presentations, analyzing market opportunities, or refining how a brand should communicate with its audience.

Evening:

I ended the day by studying, reviewing project work, and making progress on my portfolio and academic responsibilities. This part of the day is usually where I try to sharpen my thinking, organize my ideas, and keep building skills that will help me grow as a marketer and consultant.

Takeaways:

Today reminded me that success is built through repetition, discipline, and focused improvement. Between working out, reading, consulting work, and studying, I am trying to compound small daily actions into long-term growth. My goal is to keep becoming sharper, more strategic, and more capable of creating real value for the brands and teams I work with.`,
      date: new Date().toISOString(),
      isSample: false
    }
  ]);

  return (
    <main className="blog-page">
      <h1>My Blog</h1>
      <p className="page-description">
        Welcome to my blog! Here I share my thoughts, experiences, and stories from my life as a marketing consultant.
      </p>

      <section className="blogs-list-section">
        <h2>Blog Entries ({blogs.length})</h2>
        
        {blogs.length === 0 ? (
          <p className="no-content">No blog entries yet.</p>
        ) : (
          <div className="blogs-list">
            {blogs.map((blog) => (
              <article key={blog._id} className="blog-item">
                <div className="blog-header">
                  <h3>{blog.title}</h3>
                  <span className="blog-date">
                    {new Date(blog.date).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </span>
                </div>
                <p className="blog-content">{blog.content}</p>
                {blog.isSample && <span className="sample-badge">SAMPLE</span>}
              </article>
            ))}
          </div>
        )}
      </section>
    </main>
  );
}

export default Blog;
